import { GradeAgeAlignmentStudentDialogComponent } from './grade-age-alignment-student-dialog/grade-age-alignment-student-dialog.component';
import { GradeAgeAlignmentService } from './../service/grade-age-alignment.service';
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatTabGroup } from '@angular/material/tabs';

import { Router } from '@angular/router';
import moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Region } from 'src/app/model/region.model';
import { School } from 'src/app/model/school.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { DataMonitoringReportEnrollmentResult, studentsDataView } from '../model/data-monitoring-report-enrollment-result.model';
import { environment } from 'src/environments/environment';
import { UtilityService } from '../../../service/utility.service';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UrlProviderService } from 'src/app/service/urlprovider.service';

import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { DtMonService } from '../service/dtmon.service';
import { SearchStudentResponseDataView } from 'src/app/model/reports/exportsModels';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';
import { ViewGradeAlignmtTableComponent } from './view-grade-alignmt-table/view-grade-alignmt-table.component';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ThemePalette } from '@angular/material/core';

@Component({
    selector: 'app-grade-age-alignment',
    templateUrl: './grade-age-alignment.component.html',
    styleUrls: ['./grade-age-alignment.component.scss']
})
export class GradeAgeAlignmentComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appDistrictCode') appDistrictCode!: DistrictDropdownComponent;
    @ViewChild('appSchools') appSchools!: SchoolDropdownComponent;
    @ViewChild('appViewGradeAgeAlignmentTable') appViewGradeAgeAlignmentTable!: ViewGradeAlignmtTableComponent;
    @ViewChild('grade-age-alignment-table') firstTabTable: MatTable<any>; // ViewChild for the table in the first tab
    @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
    @Input() searchParm: any = [{}];

    public data: { sIds: number[]; performancePeriod: string; mpoNumber: number; fileNameLabel: string };
    isLoadingResults: boolean = false;
    isExporting: boolean = false;
    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;
    progressSubscription: Subscription;
    progressInterval: number = 500;
    lstStudentsResponseDataView: studentsDataView[] = [];

    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    selectedSchool: string = '';

    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];
    chosenSchoolYear: string = '';

    startingSchoolYearDate: Date;

    // Component variables
    resetField: boolean = false;

    // Table display
    gradeAgeAlignmentColumns: string[] = [
        'AGE',
        'P0',
        'P1',
        'P2',
        'P3',
        'P4',
        'P5',
        'TK',
        //'P6',
        //'PK',
        'K',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        'AD',
        'NA',
        'Total For Age'
    ];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns
    baseDisplayedColumns: string[] = [
        'SCHOOL.REGIONS.CODE',
        'SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR',
        'SCHOOL.SCHOOL_DISTRICT.DISTRICTS',
        'SCHOOL.NAME',
        'MSD_NUMBER',
        'SSID',
        'PERSON.LAST_NAME',
        'DOB',
        'AGE',
        'SCHOOL_ENROLLMENT_DETAILS[0].GRADE'
    ];

    // Tab labels
    selectedIndex: number = 0;

    // Table results
    gradeAgeAlignmentTable: any;
    gradeTotalTable: any;
    gradeAgeAlignmentDataSource!: MatTableDataSource<any>;
    searchResultDataSource!: MatTableDataSource<DataMonitoringReportEnrollmentResult>;
    lstSearchStudentResponseDataView: SearchStudentResponseDataView[] = [];

    // Results
    results: DataMonitoringReportEnrollmentResult[] = [];
    searchResultFilter: string = '';

    // Grade Age Alignment Table
    gradeOptions: any = [
        { INDEX: 1, GRADES: 'P0', selectable: true },
        { INDEX: 2, GRADES: 'P1', selectable: true },
        { INDEX: 3, GRADES: 'P2', selectable: true },
        { INDEX: 4, GRADES: 'P3', selectable: true },
        { INDEX: 5, GRADES: 'P4', selectable: true },
        { INDEX: 6, GRADES: 'P5', selectable: true },
        { INDEX: 7, GRADES: 'TK', selectable: true, requires: ['R'] },
        //{ INDEX: 7, GRADES: 'P6', selectable: true },
        //{ INDEX: 8, GRADES: 'PK', selectable: true, requires: ['R'] },
        { INDEX: 9, GRADES: 'K', selectable: true, requires: ['R'] },
        { INDEX: 10, GRADES: '01', selectable: true, requires: ['R'] },
        { INDEX: 11, GRADES: '02', selectable: true, requires: ['R'] },
        { INDEX: 12, GRADES: '03', selectable: true, requires: ['R'] },
        { INDEX: 13, GRADES: '04', selectable: true, requires: ['R'] },
        { INDEX: 14, GRADES: '05', selectable: true, requires: ['R'] },
        { INDEX: 15, GRADES: '06', selectable: true, requires: ['R'] },
        { INDEX: 16, GRADES: '07', selectable: true, requires: ['R'] },
        { INDEX: 17, GRADES: '08', selectable: true, requires: ['R'] },
        { INDEX: 18, GRADES: '09', selectable: true, requires: ['R'] },
        { INDEX: 19, GRADES: '10', selectable: true, requires: ['R'] },
        { INDEX: 20, GRADES: '11', selectable: true, requires: ['R'] },
        { INDEX: 21, GRADES: '12', selectable: true, requires: ['R'] },
        { INDEX: 22, GRADES: 'AD', selectable: true, requires: ['R'] },
        { INDEX: 23, GRADES: 'UG', selectable: true, requires: ['R'], static: true },
        { INDEX: 24, GRADES: 'NA', selectable: true, requires: ['N'], static: true },
        { INDEX: 25, GRADES: 'Invalid (Other)', selectable: false, static: true },
        { INDEX: 26, GRADES: 'Total For Age', selectable: false, static: true }
    ];

    ageOptions: any = [
        { AGE: '0' },
        { AGE: '1' },
        { AGE: '2' },
        { AGE: '3' },
        { AGE: '4' },
        { AGE: '5' },
        { AGE: '6' },
        { AGE: '7' },
        { AGE: '8' },
        { AGE: '9' },
        { AGE: '10' },
        { AGE: '11' },
        { AGE: '12' },
        { AGE: '13' },
        { AGE: '14' },
        { AGE: '15' },
        { AGE: '16' },
        { AGE: '17' },
        { AGE: '18' },
        { AGE: '19' },
        { AGE: '20' },
        { AGE: '21' },
        { AGE: '22' }
    ];

    correctTableOptions: any = {
        '0': { P0: true, P1: true, UG: true },
        '1': { P0: true, P1: true, P2: true, UG: true },
        '2': { P1: true, P2: true, P3: true, UG: true },
        '3': { P2: true, P3: true, P4: true, UG: true },
        '4': { P3: true, P4: true, P5: true, TK: true, PK: true, K: true, UG: true },
        '5': { P4: true, P5: true, P6: true, TK: true, PK: true, K: true, '1': true, UG: true },
        '6': { P5: true, P6: true, K: true, '01': true, '02': true, UG: true },
        '7': { P6: true, K: true, '01': true, '02': true, '03': true, UG: true },
        '8': { '02': true, '03': true, '04': true, UG: true },
        '9': { '03': true, '04': true, '05': true, UG: true },
        '10': { '04': true, '05': true, '06': true, UG: true },
        '11': { '05': true, '06': true, '07': true, UG: true },
        '12': { '06': true, '07': true, '08': true, UG: true },
        '13': { '07': true, '08': true, '09': true, UG: true },
        '14': { '08': true, '09': true, '10': true, UG: true, NA: true },
        '15': { '09': true, '10': true, '11': true, UG: true, NA: true },
        '16': { '10': true, '11': true, '12': true, UG: true, NA: true },
        '17': { '11': true, '12': true, AD: true, UG: true, NA: true },
        '18': { '12': true, AD: true, UG: true, NA: true },
        '19': { AD: true, UG: true, NA: true },
        '20': { AD: true, UG: true, NA: true },
        '21': { UG: true, NA: true },
        '22': { AD: true, UG: true, NA: true }
    };

    slightlyOffTableOptions: any = {
        '0': {},
        '1': {},
        '2': {},
        '3': {},
        '4': {},
        '5': {},
        '6': { TK: true, PK: true },
        '7': { TK: true, PK: true, K: true },
        '8': { K: true, '01': true },
        '9': { '01': true, '02': true },
        '10': { '02': true, '03': true },
        '11': { '03': true, '04': true },
        '12': { '04': true, '05': true },
        '13': { '05': true, '06': true },
        '14': { '06': true, '07': true },
        '15': { '07': true, '08': true },
        '16': { '08': true, '09': true },
        '17': { '09': true, '10': true },
        '18': { '10': true, '11': true },
        '19': { '11': true, '12': true },
        '20': { '12': true },
        '21': { AD: true },
        '22': {}
    };

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        public dtMonService: DtMonService,
        private gradeAgeAlignmentService: GradeAgeAlignmentService,
        router: Router,
        private dialog: MatDialog,
        private utilityService: UtilityService,
        private apiMsinExportsService: ApiExportsService,
        private urlProvider: UrlProviderService
    ) {
        this.setStartingSchoolYearDate();
    }

    setStartingSchoolYearDate() {
        // Set the cut-off day to go to next school year (the week after the 3rd Friday in Sept)
        let mDate = moment({ month: 8, day: 1 }); // month is 0 based

        // By default we will need to add two weeks to the first friday
        let nWeeks = 2;
        let month = mDate.month();

        // Get first Friday of the first week of the month
        mDate = mDate.date(1).day(5);

        // Check if first Friday is in the given month
        //  it may have gone to the previous month
        if (mDate.month() != month) {
            nWeeks++;
        }

        this.startingSchoolYearDate = mDate.add(nWeeks, 'weeks').add(3, 'days').toDate();
    }

    ngOnInit(): void {}

    search() {
        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};
            this.searchResultFilter = '';
            //this.dtMonService.GetDtMonGradeAgeReport

            this.gradeAgeAlignmentService.search(this.generatePayload()).subscribe({
                next: (res: any) => {
                    console.log('API returned:');
                    console.log(res);
                    if (res.students) {
                        this.results = res.students.sort((n1: DataMonitoringReportEnrollmentResult, n2: DataMonitoringReportEnrollmentResult) =>
                            n1.PERSON!.LAST_NAME! > n2.PERSON!.LAST_NAME! ? 1 : -1
                        );

                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving Grade Age Alignment Report.' };
                    }
                },
                error: (err: any) => {
                    this.results = [];
                    console.log('API returned error:');
                    console.log(err);
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving Grade Age Alignment Report.' };
                },
                complete: () => {
                    // Display current performance period
                    this.currentSchoolYear = this.selectedSchoolYear;
                    this.currentPerformancePeriod = this.selectedPerformancePeriod;

                    // Display results
                    this.isLoading = false;

                    // Set to first tab
                    this.selectedIndex = 0;
                }
            });
        }
    }

    generatePayload(): any {
        console.log('now in generatePayload()');
        let payload: any = {};

        payload.chosenRegions = this.toNumberArray(this.chosenRegions);
        payload.chosenCounties = this.toNumberArray(this.chosenCounties);
        payload.chosenSchoolDistricts = this.toNumberArray(this.chosenSchoolDistricts);
        payload.chosenSchools = this.toNumberArray(this.chosenSchools);
        payload.schoolYear = this.selectedSchoolYear;
        payload.performancePeriod = this.selectedSchoolYear;
        console.log(payload);
        return payload;
    }

    updateDataSource() {
        setTimeout(() => {
            this.updateGradeAgeAlignmentDataSource();
            this.updateResultDataSource();
        });
    }

    updateGradeAgeAlignmentDataSource() {
        // Data
        this.gradeAgeAlignmentDataSource = new MatTableDataSource<any>();
        this.gradeAgeAlignmentDataSource.data = this.buildTable();

        // Paginator
        //this.gradeAgeAlignmentDataSource.paginator = this.paginators.toArray()[0];

        // Sort
        // this.gradeAgeAlignmentDataSource.sort = this.sorts.toArray()[0];
        // const defaultSort: Sort = { active: 'CODE', direction: 'asc' };
        // this.gradeAgeAlignmentDataSource.sort.active = defaultSort.active;
        // this.gradeAgeAlignmentDataSource.sort.direction = defaultSort.direction;
        // this.gradeAgeAlignmentDataSource.sort.sortChange.emit(defaultSort);
        // this.gradeAgeAlignmentDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
    }

    updateResultDataSource() {
        // Display Columns
        this.displayedColumns = this.baseDisplayedColumns;

        // Data
        this.searchResultDataSource = new MatTableDataSource<DataMonitoringReportEnrollmentResult>();
        this.searchResultDataSource.data = this.results;

        // Paginator
        this.searchResultDataSource.paginator = this.paginators.toArray()[0];

        // Sort
        this.searchResultDataSource.sort = this.sorts.toArray()[0];
        const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
        this.searchResultDataSource.sort.active = defaultSort.active;
        this.searchResultDataSource.sort.direction = defaultSort.direction;
        this.searchResultDataSource.sort.sortChange.emit(defaultSort);
        this.searchResultDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Filter
        this.searchResultDataSource.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) != -1;
        };
    }

    // Grade Age Alignment Functions
    initTable() {
        this.gradeAgeAlignmentTable = {};

        this.ageOptions.forEach((age: any) => {
            this.gradeAgeAlignmentTable[age.AGE.toString()] = {};

            this.gradeOptions.forEach((grade: any) => {
                this.gradeAgeAlignmentTable[age.AGE.toString()][grade.GRADES] = {
                    INDEX: grade.INDEX,
                    COUNT: 0,
                    CLASS: this.checkCell(grade.GRADES, age.AGE.toString(), true)
                };
            });
        });

        this.gradeTotalTable = {};

        this.gradeOptions.forEach((grade: any) => {
            this.gradeTotalTable[grade.GRADES] = {
                INDEX: grade.INDEX,
                COUNT: 0
            };
        });
    }

    buildTable(): any[] {
        this.initTable();

        //_.filter($scope.grades, function (g) { return g.GRADES !== 'Invalid (Other)' || g.GRADES !== 'Total For Age' })

        this.results.forEach((student: any) => {
            student.AGE = student.AGE ? student.AGE : '0';
            if (
                this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE') &&
                this.gradeOptions.find((grade: any) => {
                    return grade.GRADES === this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE');
                })
            ) {
                this.gradeAgeAlignmentTable[student.AGE.toString()][this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE')].COUNT++;
                this.gradeAgeAlignmentTable[student.AGE.toString()]['Total For Age'].COUNT++;

                this.gradeAgeAlignmentTable[student.AGE.toString()][this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE')].CLASS =
                    this.checkCell(this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE'), student.AGE.toString(), false);

                this.gradeTotalTable[this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE')].COUNT++;
                this.gradeTotalTable['Total For Age'].COUNT++;
            } else {
                this.gradeAgeAlignmentTable[student.AGE.toString()]['Invalid (Other)'].COUNT++;
                this.gradeAgeAlignmentTable[student.AGE.toString()]['Total For Age'].COUNT++;

                this.gradeTotalTable['Invalid (Other)'].COUNT++;
                this.gradeTotalTable['Total For Age'].COUNT++;
            }
        });

        this.saveTable();

        let results: any[] = [];
        let ageKeys = Object.keys(this.gradeAgeAlignmentTable);

        ageKeys.forEach((age: any) => {
            let row: any = { AGE: age };
            let gradeKeys = Object.keys(this.gradeAgeAlignmentTable[age]);

            gradeKeys.forEach((grade: any) => {
                let gradeData: any = {
                    GRADES: grade,
                    CLASS: this.gradeAgeAlignmentTable[age][grade].CLASS,
                    COUNT: this.gradeAgeAlignmentTable[age][grade].COUNT
                };

                row[grade] = gradeData;
            });

            results.push(row);
        });

        let row: any = { AGE: 'Total For Grade' };
        let gradeKeys = Object.keys(this.gradeTotalTable);

        gradeKeys.forEach((grade: any) => {
            let gradeData: any = {
                GRADES: grade,
                COUNT: this.gradeTotalTable[grade].COUNT
            };

            row[grade] = gradeData;
        });
        results.push(row);

        return results;
    }

    saveTable() {}

    checkCell(grade: string, age: string, skipDefault: boolean): string {
        if (this.checkCorrectCell(grade, age)) {
            return 'light-grey-cell';
        } else if (this.checkSlightlyOffCell(grade, age)) {
            return 'dark-grey-cell italic';
        } else if (!skipDefault) {
            return 'orange-cell italic bold';
        } else {
            return '';
        }
    }

    checkCorrectCell(grade: string, age: string) {
        return this.getPropertyPipe.transform(this.correctTableOptions, age + '.' + grade);
        //return _.property('correctTableOptions' + '[' + age + ']' + '[' + grade + ']')($scope);
    }

    checkSlightlyOffCell(grade: string, age: string) {
        return this.getPropertyPipe.transform(this.slightlyOffTableOptions, age + '.' + grade);
        //return _.property('slightlyOffTableOptions' + '[' + age + ']' + '[' + grade + ']')($scope);
    }

    setFilter(searchResultDataSource: any, filter: string) {
        searchResultDataSource.filter = filter.trim().toLocaleLowerCase();
    }

    checkValid() {
        //console.log("Now running checkValid()")
        if (this.chosenRegions.length > 0 && (this.selectedSchoolYear || this.selectedPerformancePeriod || this.selectedSchool)) {
            // console.log("true")
            return true;
        }
        //console.log("false")

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    schoolYearEvent(schoolYear: string) {
        this.selectedSchoolYear = schoolYear;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedPerformancePeriod = performancePeriod;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.searchResultFilter = '';

        this.msg = {};
    }

    // Dialog Modal
    openStudentDialog(grade: string, age: number) {
        let payload = this.generatePayload();
        payload.GRADES = grade;
        payload.AGE = age;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        if (window.innerWidth >= 1400) {
            dialogConfig.minWidth = '80vw';
        } else {
            dialogConfig.minWidth = '95vw';
        }
        dialogConfig.data = payload;
        dialogConfig.panelClass = 'custom-dialog-panel';
        const dialogRef = this.dialog.open(GradeAgeAlignmentStudentDialogComponent, dialogConfig);
    }

    downloadExcelTable() {
        let payload = this.generateExportTablePayload('Excel');

        if (payload.data.length > 0) {
            this.isExporting = true;
            this.msg = new MsgModel();

            this.apiMsinExportsService.exportGradeAgeAlignmentTableReport(payload).subscribe({
                next: (res2: any) => {
                    const blob = new Blob([res2], { type: 'application/xlsx' });

                    let fileName = this.utilityService.fnMakeFileNameTime('Grade_Age_Alignment_Table_Report');

                    const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                    const url = URL.createObjectURL(renamedFile);

                    const a = document.createElement('a');
                    a.href = url;
                    fileName = fileName.trimLeft();

                    a.download = fileName + '.xlsx';
                    a.click();
                    if (a && a.parentNode === document.body) {
                        document.body.removeChild(a);
                    }

                    URL.revokeObjectURL(url);
                },
                error: (e) => {
                    this.msg = { SUCCESS: false, MSG: 'Error exporting INA/ILP Report.' };
                    this.isExporting = false;
                },
                complete: () => {
                    this.isExporting = false;
                }
            });
        }
    }

    generateExportTablePayload(fileType: string) {
        let payload = {
            settings: {
                fileType: fileType,
                schoolYear: this.currentSchoolYear.substring(0, 4)
            },
            data: this.gradeAgeAlignmentDataSource.data
        };

        return payload;
    }

    downloadExcelStudents() {
        let payload = this.generateExportStudentsPayload('Excel');

        if (payload.data.length > 0) {
            this.isExporting = true;
            this.msg = new MsgModel();

            this.apiMsinExportsService.exportGradeAgeAlignmentStudentsReport(payload).subscribe({
                next: (res2: any) => {
                    const blob = new Blob([res2], { type: 'application/xlsx' });

                    let fileName = this.utilityService.fnMakeFileNameTime('Grade_Age_Alignment_Report');

                    const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                    const url = URL.createObjectURL(renamedFile);

                    const a = document.createElement('a');
                    a.href = url;
                    fileName = fileName.trimLeft();

                    a.download = fileName + '.xlsx';
                    a.click();
                    if (a && a.parentNode === document.body) {
                        document.body.removeChild(a);
                    }

                    URL.revokeObjectURL(url);
                },
                error: (e) => {
                    this.msg = { SUCCESS: false, MSG: 'Error exporting INA/ILP Report.' };
                    this.isExporting = false;
                },
                complete: () => {
                    this.isExporting = false;
                }
            });
        }
    }

    generateExportStudentsPayload(fileType: string) {
        let payload = {
            settings: {
                fileType: fileType
            },
            data: this.searchResultDataSource.data
        };

        return payload;
    }
}
